var React = require('react');

function PlaySquared (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M0 16h16V0H0zm1.333-1.333h13.334V1.333H1.333z","clipRule":"evenodd","key":0}),React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M6.333 5.693 10.947 8l-4.614 2.307zm-.978 6.194a.75.75 0 0 0 .732.034l6.497-3.249A.75.75 0 0 0 13 8a.75.75 0 0 0-.416-.672l-6.498-3.25A.75.75 0 0 0 5 4.752v6.498c0 .262.133.5.355.638","clipRule":"evenodd","key":1})]);
}

PlaySquared.defaultProps = {"width":"16","height":"16","fill":"none","viewBox":"0 0 16 16"};

module.exports = PlaySquared;

PlaySquared.default = PlaySquared;
